const PRINT_OPTIONS = {
  ARTICLE_ONLY: {
    queryParam: "article_only",
    label: "Article",
  },
  ARTICLE_AND_QUIZ: {
    queryParam: "article_and_quiz",
    label: "Article + quiz",
  },
  ARTICLE_QUIZ_AND_ANSWERS: {
    queryParam: "article_quiz_and_answers",
    label: "Article + quiz + answers",
  },
  ARTICLE_AND_WRITE_PROMPT: {
    queryParam: "article_and_write_prompt",
    label: "Article + write prompt",
  },
  ARTICLE_WRITE_PROMPT_AND_QUIZ: {
    queryParam: "article_write_prompt_and_quiz",
    label: "Article + write prompt + quiz",
  },
  ARTICLE_WRITE_PROMPT_QUIZ_AND_ANSWERS: {
    queryParam: "article_write_prompt_quiz_and_answers",
    label: "Article + write prompt + quiz + answers",
  },
};

// Teachers, principals, and district leaders need to be able to choose whether to print the content,
// the content with the quiz, the content with the quiz and answers, the content with the write prompt,
// the content with the write prompt and quiz, or the content with the write prompt, quiz, and answers.
// Students should continue to have the single option of printing the content.
// All other authenticated users should be able to print the content, the content with the quiz,
// the content with the write prompt, or the content with the quiz and write prompt.
const getPrintOptions = ({
  isStudent,
  isTeacher,
  isAdmin,
  contentHasWritePrompt,
  isStudentPreviewOn,
  contentHasPrintableQuiz,
}) => {
  const allQuizOptions = [
    PRINT_OPTIONS.ARTICLE_AND_QUIZ,
    PRINT_OPTIONS.ARTICLE_QUIZ_AND_ANSWERS,
  ];
  const allWritePromptOptions = [
    PRINT_OPTIONS.ARTICLE_AND_WRITE_PROMPT,
    PRINT_OPTIONS.ARTICLE_WRITE_PROMPT_AND_QUIZ,
    PRINT_OPTIONS.ARTICLE_WRITE_PROMPT_QUIZ_AND_ANSWERS,
  ];

  if (isStudent || isStudentPreviewOn) {
    return [PRINT_OPTIONS.ARTICLE_ONLY];
  }

  if (isTeacher || isAdmin) {
    if (contentHasPrintableQuiz && contentHasWritePrompt) {
      return [
        PRINT_OPTIONS.ARTICLE_ONLY,
        ...allQuizOptions,
        ...allWritePromptOptions,
      ];
    }

    if (contentHasPrintableQuiz && !contentHasWritePrompt) {
      return [PRINT_OPTIONS.ARTICLE_ONLY, ...allQuizOptions];
    }

    if (!contentHasPrintableQuiz && contentHasWritePrompt) {
      return [
        PRINT_OPTIONS.ARTICLE_ONLY,
        PRINT_OPTIONS.ARTICLE_AND_WRITE_PROMPT,
      ];
    }

    return [PRINT_OPTIONS.ARTICLE_ONLY];
  }

  if (contentHasPrintableQuiz && contentHasWritePrompt) {
    return [
      PRINT_OPTIONS.ARTICLE_ONLY,
      PRINT_OPTIONS.ARTICLE_AND_QUIZ,
      PRINT_OPTIONS.ARTICLE_AND_WRITE_PROMPT,
      PRINT_OPTIONS.ARTICLE_WRITE_PROMPT_AND_QUIZ,
    ];
  }

  if (contentHasPrintableQuiz && !contentHasWritePrompt) {
    return [PRINT_OPTIONS.ARTICLE_ONLY, PRINT_OPTIONS.ARTICLE_AND_QUIZ];
  }

  if (!contentHasPrintableQuiz && contentHasWritePrompt) {
    return [PRINT_OPTIONS.ARTICLE_ONLY, PRINT_OPTIONS.ARTICLE_AND_WRITE_PROMPT];
  }

  return [PRINT_OPTIONS.ARTICLE_ONLY];
};

export { PRINT_OPTIONS, getPrintOptions };
